import React from 'react';

export default class PackageUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: 1,
      usersPackage: [],
      showMoreUsersOption: true,
      selectedUser: 1
    };
  }

  showMoreUsers() {
    if (this.state.showMoreUsersOption) {
      this.setState({
        showMoreUsersOption: false,
        size: this.state.usersPackage.length
      });
    } else {
      this.setState({
        showMoreUsersOption: true,
        size: 3
      });
    }
  }

  selectUser(user, usersPackage, clickAction) {
    user = parseInt(user, 10);
    this.props.onSelectingUser(user);
    if (clickAction) {
      this.props.onUserClickAction();
    }
    if (this.props.users.user_pricing) {
      // update pricing for fixed incerements user pricing
      usersPackage.forEach((obj) => {
        let userCount = parseInt(obj.number, 10);
        if (userCount > user) {
          let selectedUserPricing = this.props.users.user_pricing[parseInt(user, 10)]; // value selected
          let higherUserPricing = this.props.users.user_pricing[userCount]; // value nung obj sa for each

          let addedPrice = selectedUserPricing
            ? higherUserPricing - selectedUserPricing
            : higherUserPricing;
          obj.value = `+$${addedPrice}`;
        } else if (userCount < user) {
          let selectedUserPricing = this.props.users.user_pricing[user]; // value selected
          let lowerUserPricing = this.props.users.user_pricing[userCount]; // value nung obj sa for each

          let reducedPrice = lowerUserPricing
            ? selectedUserPricing - lowerUserPricing
            : selectedUserPricing;

          obj.value = `-$${reducedPrice}`;
        } else {
          obj.value = 'Selected';
        }
      });
    } else {
      //update the pricing for users
      let userPrice, userIndex;
      let pricePerUser = 0;
      if (this.props.users.price_per_additional_user) {
        pricePerUser = this.props.users.price_per_additional_user;
      } else if (this.props.users.additionalPricePerUser) {
        pricePerUser = this.props.users.additionalPricePerUser;
      }

      for (let eachUser = 0; eachUser <= usersPackage.length - 1; eachUser++) {
        userIndex = parseInt(usersPackage[eachUser].number, 10) - user;
        userPrice = Math.abs(pricePerUser * userIndex).toFixed(2);
        if (userIndex === 0) {
          usersPackage[eachUser].value = 'Selected';
        } else if (usersPackage[eachUser].number > user) {
          usersPackage[eachUser].value = `+$${userPrice}`;
        } else if (usersPackage[eachUser].number < user) {
          usersPackage[eachUser].value = `-$${userPrice}`;
        }
      }
    }

    //set the updated users value
    this.setState({
      usersPackage: usersPackage,
      selectedUser: user
    });
  }

  componentDidMount() {
    let counter = 0,
      userPrice,
      size = 1,
      minUsers = 0;
    let usersPackage = [];

    if (this.props.users.user_pricing) {
      // accomodating NEW users Logic
      let userPricing = this.props.users.user_pricing;
      if (this.props.users.default_users) {
        usersPackage.push({
          number: parseInt(this.props.users.default_users, 10),
          value: 'Included'
        });
      }
      for (const [key, value] of Object.entries(userPricing)) {
        usersPackage.push({ number: key, value: `+$${value}` });
      }
    } else {
      // OLD users Logic
      let pricePerUser = 0;
      if (this.props.users.price_per_additional_user) {
        pricePerUser = this.props.users.price_per_additional_user;
      } else if (this.props.users.additionalPricePerUser) {
        pricePerUser = this.props.users.additionalPricePerUser;
      }

      if (this.props.users.min_users) {
        minUsers = this.props.users.min_users;
      } else if (this.props.users.minimumUsers) {
        minUsers = this.props.users.minimumUsers;
      }

      if (this.props.users.max_users === 1) {
        usersPackage.push({ number: 1, value: 'Included' });
      } else {
        for (let user = parseInt(minUsers, 10); user <= this.props.users.max_users; user++) {
          if (user === parseInt(this.props.users.default_users, 10)) {
            usersPackage.push({ number: user, value: 'Included' });
          } else {
            counter++;
            userPrice = (pricePerUser * counter).toFixed(2);
            usersPackage.push({ number: user, value: `+$${userPrice}` });
          }
        }
      }
    }
    if (usersPackage.length > 3) {
      size = 3;
    } else {
      size = usersPackage.length;
    }

    this.setState({
      size: size,
      selectedUser:
        this.props.selectedUser != null
          ? this.props.selectedUser
          : parseInt(minUsers > 0 ? minUsers : this.props.users.default_users, 10)
    });

    if (this.props.selectedUser != null) {
      this.selectUser(this.props.selectedUser, usersPackage, false);
    } else {
      this.setState({
        usersPackage: usersPackage
      });
    }
  }

  render(props) {
    const classNames = require('classnames');
    const usersList = this.state.usersPackage
      .slice(0, this.state.size)
      .map(function (singleUser, index) {
        singleUser.number = parseInt(singleUser.number, 10);
        const userTileClass = classNames({
          'alert': this.state.selectedUser !== singleUser.number,
          'alert alert-success': this.state.selectedUser === singleUser.number
        });
        const userValueClass = classNames({
          'col-xs-4 text-right grey-text': this.state.selectedUser !== singleUser.number,
          'col-xs-4 text-right success-text': this.state.selectedUser === singleUser.number
        });
        return (
          <div
            className={userTileClass}
            key={index}
            onClick={() => {
              this.selectUser(singleUser.number, this.state.usersPackage, true);
            }}
          >
            <div className='row body'>
              <div className='col-xs-8'>
                {singleUser.number} {singleUser.number === 1 ? 'User' : 'Users'}
              </div>
              <div className={userValueClass}>{singleUser.value}</div>
            </div>
          </div>
        );
      }, this);
    return (
      <div className='panel-body-spacing'>
        {usersList}
        <div className='row body no-margin grey-text pointer'>
          <div className='col-xs-12'>
            {this.state.usersPackage.length > 3 && this.state.showMoreUsersOption && (
              <span
                onClick={() => {
                  this.showMoreUsers();
                }}
              >
                Show more
              </span>
            )}
            {this.state.usersPackage.length > 3 && !this.state.showMoreUsersOption && (
              <span
                onClick={() => {
                  this.showMoreUsers();
                }}
              >
                Show less
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}
